export const getSafeRedirectPath = (candidate, fallback = '/') => {
  if (!candidate || typeof candidate !== 'string') {
    return fallback;
  }

  let value = candidate.trim();
  if (!value) {
    return fallback;
  }

  try {
    value = decodeURIComponent(value);
  } catch (error) {
    // Keep raw candidate when decode is not needed or invalid.
  }

  if (value.startsWith('//')) {
    return fallback;
  }

  if (value.startsWith('/')) {
    return value;
  }

  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}` || fallback;
  } catch (error) {
    return fallback;
  }
};

export const buildLoginPath = (redirectPath) => {
  const safeRedirect = getSafeRedirectPath(redirectPath, '');
  if (!safeRedirect) {
    return '/login';
  }
  return `/login?after_login_url=${encodeURIComponent(safeRedirect)}`;
};

export const buildRegisterPath = (redirectPath, email = null) => {
  const searchParams = new URLSearchParams();
  const safeRedirect = getSafeRedirectPath(redirectPath, '');

  if (safeRedirect) {
    searchParams.set('redirect', safeRedirect);
  }
  if (email) {
    searchParams.set('email', email);
  }

  const query = searchParams.toString();
  return query ? `/register?${query}` : '/register';
};

// El chat es 1-a-1 entre usuarios: la URL acepta `userId` (el otro
// participante) y opcionalmente `productId` o `reservationId` (referencias
// mutuamente excluyentes que aparecen como chip seleccionado arriba del
// input al iniciar el chat — producto si arranca desde un product detail,
// reserva si arranca desde una reserva). `sellerId` queda como alias
// legacy de userId para no romper CTAs viejas.
export const buildGoMessagesPath = ({
  userId = null,
  sellerId = null,
  productId = null,
  reservationId = null,
} = {}) => {
  const otherUserId = userId ?? sellerId;
  if (otherUserId === null || otherUserId === undefined || otherUserId === '') {
    return '/messages';
  }
  const params = new URLSearchParams();
  params.set('userId', String(otherUserId));
  if (reservationId !== null && reservationId !== undefined && reservationId !== '') {
    // reservationId tiene prioridad sobre productId — si el caller mandó
    // ambos, asumimos que el chat es sobre la reserva (la reserva ya
    // referencia al producto del lado Spring).
    params.set('reservationId', String(reservationId));
  } else if (productId !== null && productId !== undefined && productId !== '') {
    params.set('productId', String(productId));
  }
  return `/messages?${params.toString()}`;
};
